var map = {
	"./views/bao-cao/baocao.module": [
		"../../../../../src/app/views/bao-cao/baocao.module.ts",
		"common",
		"baocao.module"
	],
	"./views/canh-bao-ton-that/canhbaotonthat.module": [
		"../../../../../src/app/views/canh-bao-ton-that/canhbaotonthat.module.ts",
		"canhbaotonthat.module"
	],
	"./views/canhbao/canhbao.module": [
		"../../../../../src/app/views/canhbao/canhbao.module.ts",
		"common",
		"canhbao.module"
	],
	"./views/ghi-chi-so/ghichiso.module": [
		"../../../../../src/app/views/ghi-chi-so/ghichiso.module.ts",
		"common",
		"ghichiso.module"
	],
	"./views/giam-sat/giamsat.module": [
		"../../../../../src/app/views/giam-sat/giamsat.module.ts",
		"giamsat.module",
		"common"
	],
	"./views/nhap-thong-tin-kh/nhapthongtinkh.module": [
		"../../../../../src/app/views/nhap-thong-tin-kh/nhapthongtinkh.module.ts",
		"common",
		"nhapthongtinkh.module"
	],
	"./views/pages/pages.module": [
		"../../../../../src/app/views/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./views/quan-ly/quanly.module": [
		"../../../../../src/app/views/quan-ly/quanly.module.ts",
		"common",
		"quanly.module"
	],
	"./views/thong-ke-trang-thai/thongketrangthai.module": [
		"../../../../../src/app/views/thong-ke-trang-thai/thongketrangthai.module.ts",
		"common",
		"thongketrangthai.module"
	],
	"./views/tien-ich/tienich.module": [
		"../../../../../src/app/views/tien-ich/tienich.module.ts",
		"common"
	],
	"./views/tim-kiem/timkiem.module": [
		"../../../../../src/app/views/tim-kiem/timkiem.module.ts",
		"common",
		"timkiem.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main